// extracted by mini-css-extract-plugin
module.exports = {"form":"AttachmentsFormModal_form__1-crN","nameDescriptionWrapper":"AttachmentsFormModal_nameDescriptionWrapper__2w_P5"};